import logoFull from '@assets/logo/full-vertical-light.svg?raw'
import icon from '@assets/logo/full-vertical-light.svg?raw'

export default {
  logoFull: h('div', { innerHTML: logoFull, style: 'line-height:0; color: rgb(var(--v-global-theme-primary))' }),
  icon: h('div', { innerHTML: icon, style: 'line-height:0; color: rgb(var(--v-global-theme-primary))' }),
  app: {
    theme: 'system',
    i18n: {
      enable: true,
      defaultLocale: 'ar',
      langConfig: [
        {
          label: 'English',
          i18nLang: 'en',
          isRTL: false,
        },
        {
          label: 'Arabic',
          i18nLang: 'ar',
          isRTL: true,
        },
      ],
    },
  },
}
